import { Box, Grid, Typography } from "@material-ui/core";
import React from "react";
import Footer from "../footer";
import { isString, isEmpty } from "lodash";

import "./style.css";

export const PAGE_HEADING_VARIANTS = Object.freeze({
  OUTSIDE_HEADING: "OUTSIDE_HEADING",
  INSIDE_HEADING: "INSIDE_HEADING",
});

const WebPageMainRegion = ({
  showFooter = true,
  children,
  pageHeading,
  headingVaraint = PAGE_HEADING_VARIANTS.INSIDE_HEADING,
  contentRootCSSClass = "",
}) => {
  return (
    <Box className="app-root-container">
      <Grid
        container
        direction="column"
        alignItems="center"
        className="flex-1 bg-page-container"
      >
        <Grid
          item
          container
          direction="column"
          className="page-content-container flex-1 cus-container"
          alignItems="center"
        >
          {headingVaraint === PAGE_HEADING_VARIANTS.OUTSIDE_HEADING &&
            isString(pageHeading) &&
            !isEmpty(pageHeading) && (
              <Typography className="page-heading page-heading-outside">
                {pageHeading}
              </Typography>
            )}
          <Box className="page-content-inner-container">
            {headingVaraint === PAGE_HEADING_VARIANTS.INSIDE_HEADING &&
              isString(pageHeading) &&
              !isEmpty(pageHeading) && (
                <Typography className="page-heading page-heading-inside">
                  {pageHeading}
                </Typography>
              )}
            <Grid container direction="column" className={contentRootCSSClass}>
              {children}
            </Grid>
          </Box>
        </Grid>
      </Grid>
      {showFooter && <Footer />}
    </Box>
  );
};

export default WebPageMainRegion;
